module.exports = ".agile-detail {\n  font-size: 1.25em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/appviews/dashboard.component.scss
// module id = ./src/app/views/appviews/dashboard.component.scss
// module chunks = main